/*
 * Created by yvesb on 28/11/2016.
 */
/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * https://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
import CFoncComplexeNVar from '../objets/CFoncComplexeNVar'
import { getStr } from '../kernel/kernel'
import FonctionDlg from '../dialogs/FonctionDlg'
export default CFoncComplexeNVar

CFoncComplexeNVar.prototype.info = function () {
  let ch = this.getNom() + '('
  for (let i = 0; i < this.nbVar; i++) {
    ch = ch + this.nomsVariables[i]
    if (i !== this.nbVar - 1) ch = ch + ','
  }
  ch = ch + ')' + ' = ' + this.calcul.chaineCalculSansPar(this.variableFormelle()) + ' (' + getStr('FoncComp') + ')'
  return ch
}
CFoncComplexeNVar.prototype.infoHist = function () {
  let ch = this.getNom() + ' : ' + getStr('FoncComp') + ' ' + getStr('ch87') + '\n' + this.info()
  if (!this.existe) ch = ch + '\n' + getStr('ch18')
  return ch
}

CFoncComplexeNVar.prototype.modifDlg = function (app, callBack1, callBack2) {
  new FonctionDlg(app, this, true, false, callBack1, callBack2)
}
